const axios = require('axios').default;

const withCsrf = (csrfToken) => {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken;
};

// === CheckoutCategory ===

export const createCheckoutCategory = ({ team, csrfToken, confirm, name }) => {
  withCsrf(csrfToken);
  return axios.post(`/teams/${team.id}/checkout_categories`, {
    checkout_category: {
      calendar_event_id: confirm.id,
      name
    }
  });
};

export const updateCheckoutCategory = ({ team, csrfToken, category, attrs }) => {
  withCsrf(csrfToken);
  return axios.patch(`/teams/${team.id}/checkout_categories/${category.id}`, {
    checkout_category: attrs
  });
};

export const updateCheckoutCategoryPosition = ({ team, csrfToken, category }) => {
  return updateCheckoutCategory({
    team,
    csrfToken,
    category,
    attrs: { position: category.position }
  });
};

export const deleteCheckoutCategory = ({ team, csrfToken, category }) => {
  withCsrf(csrfToken);
  return axios.delete(`/teams/${team.id}/checkout_categories/${category.id}`);
};

export const duplicateCheckoutCategory = ({ team, csrfToken, category }) => {
  withCsrf(csrfToken);
  return axios.post(`/teams/${team.id}/checkout_categories/${category.id}/duplicate`);
};

// === CheckoutGroup ===

export const createCheckoutGroup = ({ team, csrfToken, category, name = 'New Group' }) => {
  withCsrf(csrfToken);
  return axios.post(`/teams/${team.id}/checkout_groups`, {
    checkout_group: {
      checkout_category_id: category.id,
      name
    }
  });
};

export const updateCheckoutGroup = ({ team, csrfToken, group, attrs }) => {
  withCsrf(csrfToken);
  return axios.patch(`/teams/${team.id}/checkout_groups/${group.id}`, {
    checkout_group: attrs
  });
};

export const updateCheckoutGroupPosition = ({ team, csrfToken, group }) => {
  return updateCheckoutGroup({
    team,
    csrfToken,
    group,
    attrs: { position: group.position }
  });
};

export const moveCheckoutGroup = ({ team, csrfToken, group, newCheckoutCategoryId, position }) => {
  return updateCheckoutGroup({
    team,
    csrfToken,
    group,
    attrs: {
      checkout_category_id: newCheckoutCategoryId,
      position
    }
  });
};

export const deleteCheckoutGroup = ({ team, csrfToken, group }) => {
  withCsrf(csrfToken);
  return axios.delete(`/teams/${team.id}/checkout_groups/${group.id}`);
};

// === CheckoutGroupItem ===

export const createCheckoutGroupItem = ({ team, csrfToken, payload }) => {
  withCsrf(csrfToken);
  return axios.post(`/teams/${team.id}/checkout_group_items`, {
    checkout_group_item: payload
  });
};

export const updateCheckoutGroupItem = ({ team, csrfToken, item, attrs }) => {
  withCsrf(csrfToken);
  return axios.patch(`/teams/${team.id}/checkout_group_items/${item.id}`, {
    checkout_group_item: attrs
  });
};

export const updateCheckoutGroupItemPosition = ({ team, csrfToken, item }) => {
  return updateCheckoutGroupItem({
    team,
    csrfToken,
    item,
    attrs: { position: item.position }
  });
};

export const moveCheckoutGroupItem = ({ team, csrfToken, item, newCheckoutGroupId, position }) => {
  return updateCheckoutGroupItem({
    team,
    csrfToken,
    item,
    attrs: {
      checkout_group_id: newCheckoutGroupId,
      position
    }
  });
};

export const deleteCheckoutGroupItem = ({ team, csrfToken, item }) => {
  withCsrf(csrfToken);
  return axios.delete(`/teams/${team.id}/checkout_group_items/${item.id}`);
};

// === Helpers ===

// Whether the special "Seated Admission Chart" can be added (only one allowed per confirm)
export const canAddSeatedAdmissionChart = (confirm, checkoutCategories) => {
  if (!confirm || !confirm.seatsio_event_id) return false;
  return !flatItems(checkoutCategories).some((it) => it.seatsio_event_id);
};

// Whether the special "Seated Add-on Chart" can be added (only one allowed per confirm)
export const canAddSeatedAddOnChart = (confirm, checkoutCategories) => {
  if (!confirm || !confirm.add_on_seatsio_event_id) return false;
  return !flatItems(checkoutCategories).some((it) => it.add_on_seatsio_event_id);
};

// Whether the donation row can be added (only one allowed per confirm, and donations must be enabled)
export const canAddDonation = (confirm, checkoutCategories) => {
  if (!confirm || !confirm.donations_enabled) return false;
  return !flatItems(checkoutCategories).some((it) => it.enable_donation);
};

const flatItems = (checkoutCategories) =>
  (checkoutCategories || [])
    .flatMap((c) => c.checkout_groups || [])
    .flatMap((g) => g.checkout_group_items || []);
